import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const capi = axios.create({ baseURL: API, withCredentials: true });
capi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("customer_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const mediaFull = (path) => (path ? `${BACKEND}${path}` : null);

export function getCustomer() {
  const raw = localStorage.getItem("customer");
  return raw ? JSON.parse(raw) : null;
}
export function setCustomerSession(token, customer) {
  localStorage.setItem("customer_token", token);
  localStorage.setItem("customer", JSON.stringify(customer));
}
export function clearCustomerSession() {
  localStorage.removeItem("customer_token");
  localStorage.removeItem("customer");
}
export function isCustomerAuthed() {
  return !!localStorage.getItem("customer_token");
}

export default capi;
